import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { Image } from '@zillow/constellation';
import { Box, Button, Divider, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import { RMWContext } from '../../../providers/RMWContext';

import UserActions from '../../../actions/UserActions';

import TrackingEventsConstants from '../../../constants/TrackingEventsConstants';

import PaymentsAggregatePageModalGraphic from '../../../images/PaymentsAggregatePageModalGraphic.svg';

import { StyledImageContainer } from './StyledComponents';

type Props = {
  onClose: () => void;
};

const PaymentsAggregateViewModal = ({ onClose }: Props) => {
  const dispatch = useDispatch();

  const { paths } = useContext(RMWContext);

  const handleOnClose = (goToPaymentsAggregatePage = false) => {
    dispatch(UserActions.trackEvent({ trackingEvent: TrackingEventsConstants.ACKNOWLEDGE_PAYMENTS_AGGREGATE_MODAL }));

    if (goToPaymentsAggregatePage) {
      window.router.updateLocation(`${paths.paymentsAggregatePage}`);
    } else {
      onClose();
    }
  };

  return (
    <Modal.Root open={true} size={{ base: 'fullScreen', md: 'md' }} onOpenChange={(open) => !open && handleOnClose()}>
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content css={{ paddingBlockStart: '0 !important' }}>
            <Modal.Body css={{ padding: '0 !important' }}>
              <Box>
                <StyledImageContainer display="flex" justifyContent="center" marginBottom="lg">
                  <Image alt="Neighborhood" src={PaymentsAggregatePageModalGraphic} width="90%" />
                </StyledImageContainer>
                <Box
                  css={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '400',
                    paddingInline: '600',
                    marginBottom: '800',
                  }}
                >
                  <Heading level={2} textStyle="heading-sm">
                    All your rent payments, all in one place
                  </Heading>

                  <Paragraph>
                    Track income across all your properties, quickly see who’s paid, and send reminders to those who
                    haven’t— all from one easy-to-scan page.
                  </Paragraph>
                </Box>
              </Box>
            </Modal.Body>
            <Divider />
            <Modal.Footer css={{ display: 'flex', justifyContent: 'flex-end', paddingInline: '400' }}>
              <Button tone="brand" emphasis="filled" onClick={() => handleOnClose(true)}>
                See what&apos;s new
              </Button>
            </Modal.Footer>
            <Modal.CloseButton />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};

export default PaymentsAggregateViewModal;
